import React, { useRef } from 'react';
import get from 'lodash.get';

import MainNav from '../MainNav/MainNav';
import LogoRectangle from '../Logos/LogoRectangle';
import Dialog from '../Dialog/Dialog';
import Icon from '../Icon/Icon';

import * as styles from './Header.module.scss';

const Header = (): JSX.Element => {
    const dialogRef = useRef();
    const handleOpenNavMenu = () => {
        const openDialog = get(dialogRef, 'current.handleOpen');

        if (typeof openDialog === 'function') {
            openDialog('mobileNav');
        }
    };

    return (
        <header className="p-6 md:p-8 mb-12 md:mb-8">
            <div className={styles.Header}>
                <a className="flex items-center" href="/" title="Navigate to home page">
                    <div className="pointer-events-none">
                        <LogoRectangle />
                    </div>
                </a>
                <div className="hidden md:block">
                    <MainNav />
                </div>
                <div className="md:hidden">
                    <button
                        type="button"
                        onClick={handleOpenNavMenu}
                        className={styles.HeaderMobileMenuOpenButton}
                        title="Open menu"
                    >
                        <Icon size={24} viewBox="0 0 24 24">
                            <Icon.Menu />
                        </Icon>
                    </button>
                </div>
                <Dialog ref={dialogRef} />
            </div>
        </header>
    );
};

export default Header;
